// extracted by mini-css-extract-plugin
export default {"navLink":"ld","blinking":"md","gradientShift":"nd","float":"od","move":"pd","scroll":"qd"};